import { Link } from "react-router-dom";
import { useGyms } from "../../api/hooks";
import { OpeningHours } from "../OpeningHours";
import { gymMapUrl } from "../../lib/maps";

export function Footer() {
  const { data: gyms } = useGyms();
  return (
    <footer className="border-t border-ink-300 bg-paper text-ink-900">
      <div className="container grid gap-10 py-16 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2">
            <img src="/logo-lion.png" alt="Héraclès" className="h-11 w-11 object-contain" />
            <span className="font-display text-xl font-bold uppercase">Héraclès</span>
          </div>
          <p className="mt-4 text-sm text-ink-500">
            Box à Brest et Landerneau. Cours collectifs, coaching personnel, Kids.
          </p>
        </div>

        {gyms?.map((gym) => (
          <div key={gym.id}>
            <h3 className="text-sm font-bold uppercase tracking-wider text-brand-500">{gym.name}</h3>
            <address className="mt-3 not-italic text-sm text-ink-500">
              <a
                href={gymMapUrl(gym)}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-brand-500"
              >
                {gym.address}
              </a>
              <br />
              <a href={`tel:${gym.phone.replace(/\s/g, "")}`} className="hover:text-brand-500">
                {gym.phone}
              </a>
            </address>
            <OpeningHours hours={gym.openingHours} className="mt-3 text-xs text-ink-500" />
          </div>
        ))}
      </div>

      <div className="border-t border-ink-300">
        <div className="container flex flex-col items-center justify-between gap-2 py-6 text-xs text-ink-500 md:flex-row">
          <p>© {new Date().getFullYear()} Héraclès — Tous droits réservés</p>
          <div className="flex items-center gap-4">
            <Link to="/mentions-legales" className="hover:text-brand-500">Mentions légales</Link>
            <Link to="/politique-confidentialite" className="hover:text-brand-500">Confidentialité</Link>
            <a
              href="https://journal.crossfit.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="The CrossFit Journal"
            >
              <img
                src="/crossfit-journal.png"
                alt="The CrossFit Journal"
                className="h-5 w-auto opacity-70 transition-opacity hover:opacity-100"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
